// extracted by mini-css-extract-plugin
module.exports = {"shipToNewAddress":"FR","linkContainer":"GR"};